import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function PaginationComponent_div_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function PaginationComponent_div_0_ng_template_2_span_8_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 12);
    ɵngcc0.ɵɵlistener("click", function PaginationComponent_div_0_ng_template_2_span_8_Template_span_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(3); return ctx_r8.handleShowMore($event); });
    ɵngcc0.ɵɵtext(1, "Show More");
    ɵngcc0.ɵɵelementEnd();
} }
function PaginationComponent_div_0_ng_template_2_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelementStart(1, "div", 14);
    ɵngcc0.ɵɵelementStart(2, "span", 15);
    ɵngcc0.ɵɵtext(3, "Loading...");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
const _c0 = function (a0) { return { "disabled": a0 }; };
function PaginationComponent_div_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵelementStart(2, "div", 7);
    ɵngcc0.ɵɵelementStart(3, "p");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 6);
    ɵngcc0.ɵɵelementStart(6, "div", 8);
    ɵngcc0.ɵɵelementStart(7, "div", 9);
    ɵngcc0.ɵɵtemplate(8, PaginationComponent_div_0_ng_template_2_span_8_Template, 2, 0, "span", 10);
    ɵngcc0.ɵɵtemplate(9, PaginationComponent_div_0_ng_template_2_div_9_Template, 4, 0, "div", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate2("", ctx_r3.currentFrom, " of ", ctx_r3.total, "");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c0, ctx_r3.isLoadMoreDisabled));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r3.loading);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.loading);
} }
function PaginationComponent_div_0_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵtext(1, " pagination 1-2-3 ");
    ɵngcc0.ɵɵelementEnd();
} }
function PaginationComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, PaginationComponent_div_0_ng_container_1_Template, 1, 0, "ng-container", 2);
    ɵngcc0.ɵɵtemplate(2, PaginationComponent_div_0_ng_template_2_Template, 10, 7, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵtemplate(4, PaginationComponent_div_0_ng_template_4_Template, 2, 0, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r2 = ɵngcc0.ɵɵreference(3);
    const _r4 = ɵngcc0.ɵɵreference(5);
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.typeOfPaginationEnum.LoadMore === ctx_r0.type)("ngIfThen", _r2)("ngIfElse", _r4);
} }
class newValue {
}
var TypeOfPaginationEnum;
(function (TypeOfPaginationEnum) {
    TypeOfPaginationEnum["LoadMore"] = "LoadMore";
    TypeOfPaginationEnum["Pagination"] = "Pagination";
})(TypeOfPaginationEnum || (TypeOfPaginationEnum = {}));

class PaginationService {
    constructor() {
        this.moveSubject = new Subject();
        this.page = new newValue();
        this.currentFrom = 1;
        this.move$ = this.moveSubject.asObservable();
    }
    move(p) {
        if (p != undefined) {
            this.page.total = +p.total;
            this.page.currentFrom = this.currentShow(p);
            this.page.isLast = this.isLast(p);
            this.moveSubject.next(this.page);
        }
    }
    isLast(p) {
        return this.currentFrom >= +p.total;
    }
    currentShow(p) {
        if (+p.from == 0) {
            if (+p.perPage > +p.total) {
                this.currentFrom = +p.total;
            }
            else {
                this.currentFrom = +p.perPage;
            }
        }
        else {
            if ((+p.currentPage * +p.perPage) > +p.total) {
                this.currentFrom = +p.total;
            }
            else {
                this.currentFrom = +p.perPage * +p.currentPage;
            }
        }
        return this.currentFrom;
    }
}
PaginationService.ɵfac = function PaginationService_Factory(t) { return new (t || PaginationService)(); };
PaginationService.ɵprov = i0.ɵɵdefineInjectable({ factory: function PaginationService_Factory() { return new PaginationService(); }, token: PaginationService, providedIn: "root" });
PaginationService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PaginationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class PaginationComponent {
    constructor(paginationService) {
        this.paginationService = paginationService;
        this.isActive = false;
        this.type = TypeOfPaginationEnum.LoadMore;
        this.paging = { currentPage: 0, total: 0, from: 0, perPage: 1 };
        this.loading = false;
        this.showMore = new EventEmitter();
        this.subscriptions = new Subscription();
        this.total = 1;
        this.currentFrom = 1;
        this.isLoadMoreDisabled = false;
    }
    ngOnInit() {
        console.log('pagination');
        this.subscriptions.add(this.paginationService.move$.pipe().subscribe(page => {
            this.currentFrom = page.currentFrom;
            this.total = page.total;
            this.isLoadMoreDisabled = page.isLast;
        }, error => {
            console.log('ERROR');
        }));
        this.changeLoadMorePagination(this.paging);
    }
    get typeOfPaginationEnum() {
        return TypeOfPaginationEnum;
    }
    handleShowMore(event) {
        if (+this.paging.currentPage < +this.paging.lastPage) {
            this.showMore.emit(event);
        }
    }
    changeLoadMorePagination(p) {
        this.paginationService.move(p);
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
PaginationComponent.ɵfac = function PaginationComponent_Factory(t) { return new (t || PaginationComponent)(ɵngcc0.ɵɵdirectiveInject(PaginationService)); };
PaginationComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PaginationComponent, selectors: [["lib-pagination"]], inputs: { isActive: "isActive", type: "type", paging: "paging", loading: "loading" }, outputs: { showMore: "showMore" }, decls: 1, vars: 1, consts: [["class", "pagination-container", 4, "ngIf"], [1, "pagination-container"], [4, "ngIf", "ngIfThen", "ngIfElse"], ["loadMore", ""], ["pagination", ""], [1, "learn-more"], [1, "row"], [1, "item-counter", "col", "d-flex", "justify-content-center"], [1, "col", "d-flex", "justify-content-center"], [1, "rectangle-button", 3, "ngClass"], ["class", "button-content", 3, "click", 4, "ngIf"], ["class", "button-content", 4, "ngIf"], [1, "button-content", 3, "click"], [1, "button-content"], ["role", "status", 1, "spinner-border"], [1, "visually-hidden"], [1, "pagination-box"]], template: function PaginationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, PaginationComponent_div_0_Template, 6, 3, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.isActive);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgClass], styles: [".pagination-container[_ngcontent-%COMP%]   .rectangle-button[_ngcontent-%COMP%]{display:inline-block;border:solid 2px #000000}.pagination-container[_ngcontent-%COMP%]   .rectangle-button[_ngcontent-%COMP%]   .button-content[_ngcontent-%COMP%]{display:block;padding:20px 44px 19px;cursor:pointer;color:#000}.pagination-container[_ngcontent-%COMP%]   .rectangle-button.disabled[_ngcontent-%COMP%]{border:solid 2px #8b8a8a;pointer-events:none;cursor:pointer}.pagination-container[_ngcontent-%COMP%]   .rectangle-button.disabled[_ngcontent-%COMP%]   .button-content[_ngcontent-%COMP%]{color:#8b8a8a}"] });
PaginationComponent.ctorParameters = () => [
    { type: PaginationService }
];
PaginationComponent.propDecorators = {
    isActive: [{ type: Input }],
    type: [{ type: Input }],
    paging: [{ type: Input }],
    loading: [{ type: Input }],
    showMore: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PaginationComponent, [{
        type: Component,
        args: [{
                selector: 'lib-pagination',
                template: "<div class=\"pagination-container\" *ngIf=\"isActive\">\r\n  <ng-container\r\n      *ngIf=\"typeOfPaginationEnum.LoadMore === type; then loadMore; else pagination\">\r\n  </ng-container>\r\n\r\n  <ng-template #loadMore>\r\n    <div class=\"learn-more\">\r\n      <div class=\"row\">\r\n        <div class=\"item-counter  col d-flex justify-content-center\">\r\n          <p>{{ currentFrom }} of {{ total }}</p>\r\n        </div>\r\n      </div>\r\n      <div class=\"row\" >\r\n        <div class=\"col d-flex justify-content-center\">\r\n          <div class=\"rectangle-button\" [ngClass]=\"{'disabled':isLoadMoreDisabled}\" >\r\n            <span *ngIf=\"!loading\" class=\"button-content\" (click)=\"handleShowMore($event)\">Show More</span>\r\n            <div class=\"button-content\" *ngIf=\"loading\">\r\n              <div class=\"spinner-border\" role=\"status\">\r\n                <span class=\"visually-hidden\">Loading...</span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </ng-template>\r\n  <ng-template #pagination>\r\n    <div class=\"pagination-box\">\r\n      pagination 1-2-3\r\n    </div>\r\n  </ng-template>\r\n</div>\r\n",
                styles: [".pagination-container .rectangle-button{display:inline-block;border:solid 2px #000000}.pagination-container .rectangle-button .button-content{display:block;padding:20px 44px 19px;cursor:pointer;color:#000}.pagination-container .rectangle-button.disabled{border:solid 2px #8b8a8a;pointer-events:none;cursor:pointer}.pagination-container .rectangle-button.disabled .button-content{color:#8b8a8a}\n"]
            }]
    }], function () { return [{ type: PaginationService }]; }, { isActive: [{
            type: Input
        }], type: [{
            type: Input
        }], paging: [{
            type: Input
        }], loading: [{
            type: Input
        }], showMore: [{
            type: Output
        }] }); })();

class PaginationModule {
}
PaginationModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: PaginationModule });
PaginationModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function PaginationModule_Factory(t) { return new (t || PaginationModule)(); }, imports: [[
            CommonModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PaginationModule, { declarations: function () { return [PaginationComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [PaginationComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PaginationModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    PaginationComponent
                ],
                imports: [
                    CommonModule,
                ],
                exports: [
                    PaginationComponent
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of pagination
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PaginationComponent, PaginationModule, PaginationService, TypeOfPaginationEnum, newValue };

//# sourceMappingURL=scoop-lli-pagination.js.map